import APIUtils from '@spothero/utils/api';

const CityAPI = {
    get(slug) {
        return APIUtils.get(`cities/${slug}/`);
    },

    getAll() {
        return APIUtils.get(`cities/`);
    },
};

export default CityAPI;
